import React from 'react'

// Navigation item component for sidebar

const NavItem = ({ icon, label, subtitle, active, onClick, collapsed }) => {
    return (
        <button
            onClick={onClick}
            title={collapsed ? label : undefined}
            className={`group relative w-full flex items-center rounded-lg transition-colors duration-150 ${
                collapsed ? 'justify-center px-0 py-2' : 'gap-2.5 px-3 py-2'
            } ${
                active
                    ? 'bg-blue-50 dark:bg-blue-900/25 text-blue-600 dark:text-blue-400'
                    : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700/60 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
        >
            {active && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-0.5 rounded-full bg-blue-500 dark:bg-blue-400" />
            )}
            <span className={`flex items-center justify-center rounded-md w-7 h-7 flex-shrink-0 transition-colors ${
                active ? 'bg-blue-100 dark:bg-blue-900/40' : 'group-hover:bg-gray-200/60 dark:group-hover:bg-gray-600/40'
            }`}>
                {icon}
            </span>
            {!collapsed && (
                <span className="min-w-0 text-left leading-tight">
                    <span className="block font-medium text-[13px] truncate">{label}</span>
                    {subtitle && (
                        <span className="block text-[10.5px] text-gray-400 dark:text-gray-500 truncate">{subtitle}</span>
                    )}
                </span>
            )}

            {collapsed && (
                <span className="pointer-events-none absolute left-full ml-2 whitespace-nowrap rounded-md bg-gray-900 dark:bg-gray-700 text-white text-xs font-medium px-2.5 py-1.5 opacity-0 scale-95 origin-left transition-all duration-150 group-hover:opacity-100 group-hover:scale-100 z-50 shadow-lg">
                    {label}
                </span>
            )}
        </button>
    );
};

export default NavItem
